import { useLogEvent } from "../../../hooks/log";
import FrequentlyAskedQuestions from "../../common/FrequentlyAskedQuestions";
import classNames from "./Support.module.css";

export function NeedHelp(props: { title?: string }) {
  const logEvent = useLogEvent();
  return (
    <div className={classNames.NeedHelp}>
      {props.title && <h2>{props.title}</h2>}
      <p>
        Contact us at{" "}
        <a
          href="mailto:team@langfinity.ai?subject=Langfinity%20Support"
          onClick={() => {
            logEvent({ type: "click_email_support" });
          }}
        >
          team@langfinity.ai
        </a>{" "}
        for a response within 24 hours or call{" "}
        <a
          href="tel:+1-323-364-0815"
          onClick={() => {
            logEvent({ type: "click_call_support" });
          }}
        >
          +1-323-364-0815
        </a>{" "}
        for urgent assistance
      </p>
    </div>
  );
}

export default function Support() {
  return (
    <div className={classNames.Support}>
      <h1>Support</h1>
      <FrequentlyAskedQuestions />
      <NeedHelp title="Still need help?" />
    </div>
  );
}
